import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useResponsive } from "react-hooks-responsive";
import { Link } from "react-router-dom";
import {
  Grid,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  Alert,
} from "react-bootstrap";
import Radio from "../components/CustomRadio/CustomRadio.jsx";
import { constants } from "../redux/returnCall/actions";
import { commonConstants } from "../redux/common/actions";
import { getFormattedUser } from "../services/auth";
import NotificationSystem from "react-notification-system";
import { style as notificationStyling } from "../variables/Variables.jsx";
import ClipLoader from "react-spinners/ClipLoader";
import DatetimePicker from "./Components/DatePicker.jsx";

const {
  UPDATE_RETURN_CALL_FORM_FIELD,
  RESOLVE_RETURN_CALL,
  RETRIEVE_RETURN_CALL,
} = constants;
const { REQUEST } = commonConstants;

const ReturnCall = ({ history }) => {
  const { loading, success, error, ...form } = useSelector(
    (state) => state.returnCalls
  );
  const pathParams = window.location.pathname.split("/");
  const callReportId = parseInt(pathParams[pathParams.length - 1])
    ? parseInt(pathParams[pathParams.length - 1])
    : null;
  const dispatch = useDispatch();
  // initial page fetch - has a dependency due to browser fun, normally this is empty(navigating from one report to another does not trigger fetch when empty)
  useEffect(() => {
    setNotificationSystem(notificationSystem);
    if (callReportId) {
      dispatch({
        type: RETRIEVE_RETURN_CALL + REQUEST,
        payload: { id: callReportId },
      });
    }
    return () => {};
  }, [callReportId]);
  // retrieve user
  const [callTakerId, setCallTakerId] = useState(null);
  useEffect(() => {
    async function getAuth() {
      const user = await getFormattedUser();
      setCallTakerId(user.id);
    }
    getAuth().then();
  }, []);
  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current;
    if (notificationSystem && success.message) {
      notificationSystem.addNotification({
        message: success.message,
        level: "info",
        position: "tc",
      });
      // On successful resolution, redirect to return calls page
      history.push("/admin/return-calls", {
        type: RESOLVE_RETURN_CALL,
        message: success.message,
      });
    }
    if (notificationSystem && error.message) {
      notificationSystem.addNotification({
        message: error.message,
        level: "error",
        position: "tc",
      });
    }
    return () => {};
  }, [success.message, error.message]);
  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById("top-of-the-form-to-ya").scrollIntoView(true);
    document.getElementById("top-of-the-form-to-ya").scrollIntoView(true);
    return () => {};
  }, [error.message]);

  const [_notificationSystem, setNotificationSystem] = useState({});

  let {
    callEntryType,
    name,
    email,
    cellPhone,
    homePhone,
    isVeteran,
    veteranBranch,
    yearsOfMilitaryService,
    isDisabled,
    receivedVaTreatment,
    gender,
    veteranRank,
    yearsOfPoliceService,
    country,
    provinceState,
    city,
    departmentSize,
    callerType,
    age,
    coplineReferral,
    headTrauma,
    impairment,
    currentStruggle,
    callStart,
    callEnd,
    callReason,
    callWasReferred,
    referralDetails,
    returnCall,
    returnCallDetails,
    returnCallFollowUpNotes,
    originCallReportId,
    callFulfilled,
    callType,
    returnCallDate,
    id,
    safeReturnCallDetails,
    combatExperience,
    treatedForPtsd,
    otherMedicalCondition,
  } = form;
  const formattedPayload = {
    name,
    email,
    cellPhone,
    homePhone,
    isVeteran,
    veteranBranch,
    yearsOfMilitaryService,
    isDisabled,
    receivedVaTreatment,
    gender,
    veteranRank,
    yearsOfPoliceService,
    country,
    provinceState,
    city,
    departmentSize,
    callerType,
    age,
    coplineReferral,
    headTrauma,
    impairment,
    currentStruggle,
    callStart,
    callEnd,
    callReason,
    callWasReferred,
    referralDetails,
    returnCall,
    returnCallDetails,
    returnCallFollowUpNotes,
    returnCallDate,
    callTakerId,
    originCallReportId,
    id,
    callType,
    callEntryType,
    callFulfilled,
    safeReturnCallDetails,
    combatExperience,
    treatedForPtsd,
    otherMedicalCondition,
  };

  const isReturnCall = callType === "RETURN";

  const breakpoints = { xs: 0, sm: 425, md: 1024 };
  const { size } = useResponsive(breakpoints);
  const radioStyle = size === "xs" ? { transform: "scale(3)", margin: 16 } : {};
  const notificationSystem = useRef();
  const returnCallDateRequired = returnCall;

  if (loading.source === RETRIEVE_RETURN_CALL) {
    return (
      <div className="main-content" style={{ textAlign: "center" }}>
        <ClipLoader loading size={50} color="grey" />
      </div>
    );
  }

  return (
    <div className="main-content">
      <NotificationSystem
        ref={notificationSystem}
        style={notificationStyling}
      />
      <Form>
        <Grid fluid>
          {originCallReportId > 0 && (
            <div>
              <Row>
                <Col xs={12} sm={12}>
                  <Alert bsStyle="warning">
                    <Link
                      to={`/admin/view-call-entry/${originCallReportId}?readOnly=true`}
                    >
                      Original Call Report
                    </Link>
                  </Alert>
                </Col>
              </Row>
            </div>
          )}
          {isReturnCall && (
            <Row>
              <Col sm={12}>
                <FormGroup>
                  <ControlLabel>Call Back Details</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    id="safe-return-call-details"
                    name="safeReturnCallDetails"
                    value={safeReturnCallDetails}
                    disabled={true}
                    style={{ height: "200px" }}
                  />
                </FormGroup>
              </Col>
              <Col sm={12}>
                <FormGroup>
                  <ControlLabel>
                    Return Call Follow Up Notes
                    {<span style={{ color: "red" }}>{" *"}</span>}
                  </ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    id="return-call-follow-up-notes"
                    name="returnCallFollowUpNotes"
                    value={returnCallFollowUpNotes}
                    disabled={callFulfilled}
                    style={{ height: "200px" }}
                    onChange={(event) => handleChange(dispatch, event)}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          <h4 className="title">Additional Return Call</h4>
          <Row>
            <Col xs={12} sm={4}>
              <FormGroup>
                <ControlLabel>
                  Did the caller indicate he/she would like a return call?
                </ControlLabel>
                <Radio
                  number="return-call-1"
                  option={true}
                  name="returnCall"
                  onChange={(event) =>
                    handleChange(dispatch, event, "returnCall")
                  }
                  checked={returnCall}
                  disabled={callFulfilled}
                  label="Yes"
                  style={radioStyle}
                />
                <Radio
                  number="return-call-2"
                  option={false}
                  name="returnCall"
                  onChange={(event) =>
                    handleChange(dispatch, event, "returnCall")
                  }
                  checked={!returnCall}
                  disabled={callFulfilled}
                  label="No"
                  style={radioStyle}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {returnCall && (
              <>
                <Col xs={12} sm={4}>
                  <FormGroup>
                    <ControlLabel>
                      Requested Return Call Date
                      {returnCallDateRequired ? (
                        <span style={{ color: "red" }}>{" *"}</span>
                      ) : (
                        ""
                      )}
                    </ControlLabel>
                    <DatetimePicker
                      field="returnCallDate"
                      value={
                        returnCallDate ? new Date(returnCallDate) : new Date()
                      }
                      handleChange={(event) =>
                        handleChange(dispatch, event, "returnCallDate")
                      }
                      readOnly={callFulfilled}
                    />
                  </FormGroup>
                </Col>
              </>
            )}
          </Row>
          {returnCall && (
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup>
                  <ControlLabel>Call Back Details</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    id="return-call-details"
                    name="returnCallDetails"
                    value={returnCallDetails}
                    disabled={callFulfilled}
                    style={{ height: "200px" }}
                    onChange={(event) => handleChange(dispatch, event)}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          {!callFulfilled && (
            <Row style={{ marginTop: 20 }}>
              <Col xs={12} sm={12}>
                <Button
                  style={{ marginRight: "15px" }}
                  bsStyle="primary"
                  bsSize="lg"
                  // disabled={submitDisabled}
                  onClick={() => {
                    dispatch({
                      type: RESOLVE_RETURN_CALL + REQUEST,
                      payload: formattedPayload,
                    });
                  }}
                >
                  Resolve
                </Button>
                <Button
                  bsStyle="warning"
                  type="reset"
                  bsSize="lg"
                  onClick={() => {
                    window.location.href = "/admin/return-calls";
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
          {callFulfilled && (
            <Row style={{ marginTop: 20 }}>
              <Col xs={12} sm={12}>
                <Button
                  bsStyle="warning"
                  type="reset"
                  bsSize="lg"
                  onClick={() => {
                    window.location.href = "/admin/return-calls";
                  }}
                >
                  Back
                </Button>
              </Col>
            </Row>
          )}
        </Grid>
      </Form>
    </div>
  );
};

function handleChange(dispatch, event, formField) {
  let field = null;
  let value = null;
  if (["callStart", "callEnd", "returnCallDate"].includes(formField)) {
    field = formField;
    value = event._d;
  } else if (event.target) {
    field = event.target.name;
    value = event.target.value;
    value = value === "true" ? true : value;
    value = value === "false" ? false : value;
  } else {
    // select form items
    field = formField;
    value = event;
  }
  return dispatch({ type: UPDATE_RETURN_CALL_FORM_FIELD, field, value });
}

export default ReturnCall;
